import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDropzone } from 'react-dropzone';
import Translate from '../Translate/Translate';
import Tooltip from '@sumologic/yama-ds-components/components/Tooltip';

function FileUploader({
    inputPlaceholder,
    multiple,
    handleFileUploaded,
    handleRemoveFile,
    className,
    files,
    filters,
    showTooltip
}) {
    const onDrop = useCallback(acceptedFiles => {
        handleFileUploaded(acceptedFiles);
    }, []);

    const accept = filters.length === 0 ? '' : filters.join(',');

    const { getRootProps, getInputProps, acceptedFiles } = useDropzone({
        onDrop,
        multiple,
        accept
    });

    const defaultPlaceholder = multiple ? (
        <Translate message={'Drag some files here or click to select files'} />
    ) : (
        <Translate message={'Drag some file here or click to select file'} />
    );
    const placeholderWithImage = (
        <>
            <i
                className="icon icon-xl icon-document2 mb-4"
                style={{
                    fontSize: '2.6rem',
                    display: 'block'
                }}
            />
            {defaultPlaceholder}
        </>
    );
    const placeholder = inputPlaceholder
        ? inputPlaceholder
        : placeholderWithImage;

    const listGridItem = (index, file) => {
        return (
            <div className={'col-4 list-grid-col-item col mb-1'} key={index}>
                <div
                    className={
                        ' list-grid-item ' +
                        ((index + 1) % 3 === 0 ? 'me-0 ' : 'me-3 ') +
                        (index + 1 > 3 ? 'mt-2' : 'mt-0')
                    }
                >
                    <span>{file.path}</span>

                    <button
                        className={'icon-btn'}
                        onClick={() => {
                            handleRemoveFile(index, file);
                        }}
                    >
                        <i className={'icon icon-cross'} />
                    </button>
                </div>
            </div>
        );
    };

    let filesList = files.map((file, index) => listGridItem(index, file));
    if (showTooltip) {
        filesList = files.map((file, index) => (
            <Tooltip
                key={index}
                title={<div>{file.tooltip}</div>}
                placement="bottom"
                arrow
            >
                {listGridItem(index, file)}
            </Tooltip>
        ));
    }
    return (
        <div id={'file-uploader'}>
            <div className={'dropzone-container ' + className}>
                <div {...getRootProps({})}>
                    <input {...getInputProps()} />
                    <p className={'dropzone-text font-italic'}>{placeholder}</p>
                </div>
            </div>
            {files.length !== 0 && (
                <div className={'mt-2 p-0 list-grid container-fluid'}>
                    <h5>
                        <Translate message="Files" />:
                    </h5>
                    <div className={'g-0 row'}>{filesList}</div>
                </div>
            )}
        </div>
    );
}

FileUploader.propTypes = {
    inputPlaceholder: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    multiple: PropTypes.bool,
    handleFileUploaded: PropTypes.func,
    className: PropTypes.string,
    files: PropTypes.array,
    handleRemoveFile: PropTypes.func,
    filters: PropTypes.array,
    showTooltip: PropTypes.bool
};
FileUploader.defaultProps = {
    multiple: false,
    handleFileUploaded: () => {},
    handleRemoveFile: () => {},
    className: '',
    files: [],
    filters: [],
    showTooltip: false
};

export default FileUploader;
